import { PRODUCTS, FAQS } from "@/data/content";
import { SITE } from "@/config/site";

export const SITE_URL = "https://metalmuse.ca";
export const DEFAULT_OG_IMAGE =
  "https://images.unsplash.com/photo-1691036561573-4b76998b60de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

// BreadcrumbList structured data
export const crumbs = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

// Product catalog structured data (Shop)
export const productsJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "MetalMuse Metal Prints",
  itemListElement: PRODUCTS.map((p, i) => ({
    "@type": "ListItem",
    position: i + 1,
    item: {
      "@type": "Product",
      name: p.name,
      description: p.description,
      image: p.image,
      brand: { "@type": "Brand", name: "MetalMuse" },
      category: "Metal Photo Print",
      offers: {
        "@type": "Offer",
        price: p.price,
        priceCurrency: p.currency,
        availability: "https://schema.org/InStock",
        url: `${SITE_URL}/order?product=${encodeURIComponent(p.name)}`,
        seller: { "@type": "Organization", name: "MetalMuse" },
      },
    },
  })),
});

// FAQPage structured data (Faq)
export const faqJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

// ContactPage / local business reference (Contact)
export const contactJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: "Contact MetalMuse",
  url: `${SITE_URL}/contact`,
  mainEntity: {
    "@type": "LocalBusiness",
    name: "MetalMuse",
    email: SITE.email,
    telephone: "+1-639-525-8969",
    address: {
      "@type": "PostalAddress",
      streetAddress: "120-2339 Willow Road",
      addressLocality: "Regina",
      addressRegion: "SK",
      postalCode: "S4V 4C1",
      addressCountry: "CA",
    },
  },
});
